import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { DataLayerService } from '@ninety/platform/services/services/google-analytics/data-layer.service';
import { GoogleAnalyticsService } from '@ninety/platform/services/services/google-analytics/google-analytics.service';
import { DataLayerEffects } from '@ninety/platform/state/app-global/analytics/google-analytics/data-layer.effects';

const providers = [DataLayerService, GoogleAnalyticsService];

const effects = [DataLayerEffects];

@NgModule({
  imports: [EffectsModule.forFeature(effects)],
  providers: [...providers],
})
export class GoogleAnalyticsModule {}
